/**
 * A Web Worker that provides a non-throttled interval timer for background tasks.
 * Browsers throttle main-thread timers aggressively when a tab is hidden,
 * but Workers have a higher tolerance.
 */
const workerCode = `
  let intervalId = null;

  self.onmessage = (e) => {
    const { action, ms } = e.data;

    if (action === 'start') {
      if (intervalId) clearInterval(intervalId);
      intervalId = setInterval(() => {
        self.postMessage('tick');
      }, ms || 10000);
      // Send an immediate tick to start
      self.postMessage('tick'); 
    } else if (action === 'stop') {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }
  };
`;

class BackgroundTimer {
    constructor(ms, onTick) {
        this.ms = ms;
        this.onTick = onTick;
        this.worker = null;
        this.blobUrl = null;
    }

    start() {
        if (this.worker) return;

        const blob = new Blob([workerCode], { type: 'application/javascript' });
        this.blobUrl = URL.createObjectURL(blob);
        this.worker = new Worker(this.blobUrl);

        this.worker.onmessage = (e) => {
            if (e.data === 'tick' && this.onTick) {
                this.onTick();
            }
        };

        this.worker.postMessage({ action: 'start', ms: this.ms });
    }

    stop() {
        if (this.worker) {
            this.worker.postMessage({ action: 'stop' });
            this.worker.terminate();
            this.worker = null;
        }
        if (this.blobUrl) {
            URL.revokeObjectURL(this.blobUrl);
            this.blobUrl = null;
        }
    }
}

export default BackgroundTimer;
